import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex space-x-2" }
const _hoisted_2 = { class: "flex flex-col w-full h-96 space-y-2" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "flex text-brand-light-gray text-sm px-2" }

import {computed, PropType} from "vue";
import {ChatMessageInterface} from "@/interfaces/ChatMessageInterface";
import {DateTime} from "luxon";
import {actionSheetController, alertController, useIonRouter} from "@ionic/vue";
import useCamera from "@/composables/useCamera";
import {CameraResultType, CameraSource} from "@capacitor/camera";
import ApiService from "@/services/api/apiService";
import {Observable, ObservableEvent} from "@/services/observable/Observable";
import * as sanitizeHtml from 'sanitize-html';
import UserListItem from "@/components/UserListItem.vue";
import {UserBasicInformationInterface} from "@/interfaces/UserBasicInformationInterface";
import {ChatParticipantInterface} from "@/interfaces/ChatParticipantInterface";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatMessage',
  props: {
  isAuthUser: {
    type: Boolean,
    default: false
  },
  message: {
    type: Object as PropType<ChatMessageInterface>,
    required: true
  }
},
  emits: ['onDelete'],
  setup(__props, { emit: __emit }) {


const props = __props

const emits = __emit

const messageTime = computed(() => {
  const dateTime = DateTime.fromISO(props.message?.created_at)

  // is today
  if (DateTime.now().toISODate() === dateTime.toISODate()) return `Today @ ${dateTime.toFormat('HH:mm')}`

  // is yesterday
  if (DateTime.now().minus({day: 1}).toISODate() === dateTime.toISODate()) return `Yesterday @ ${dateTime.toFormat('HH:mm')}`

  return `${dateTime.toFormat('EEE d')} ${dateTime.toFormat('MMM')} @ ${dateTime.toFormat('HH:mm')}`

})

const ionRouter = useIonRouter()

const viewProfile = async (user: ChatParticipantInterface) => {
  if (user.is_auth_user) return
  ionRouter.navigate({
    name: 'FlirtUserProfile',
    params: {
      userId: user.id
    }
  }, 'forward', 'push')
}

const messageOptions = async () => {
  if (!props.isAuthUser) return

  const actionSheet = await actionSheetController.create({
    buttons: [
      {
        text: 'Delete',
        role: 'destructive',
        handler: async () => {
          const alert = await alertController.create({
            header: 'Delete Message',
            message: 'Are you sure you want to delete this message?',
            buttons: [
              {
                text: 'Yes',
                role: 'destructive',
                handler: () => {
                  emits('onDelete', props.message)
                }
              },
              {
                text: 'Cancel',
              }
            ]
          })
          await alert.present()
        }
      },
      {
        text: 'Cancel',
        role: 'cancel'
      }
    ]
  })

  await actionSheet.present()


}


return (_ctx: any,_cache: any) => {
  const _component_photo_consumer = _resolveComponent("photo-consumer")!
  const _component_photo_provider = _resolveComponent("photo-provider")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{
            'items-end' : __props.isAuthUser
        }, "flex flex-col mt-5 px-4 space-y-2"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass([{
                    'pr-20' : !__props.isAuthUser,
                    'pl-20' : __props.isAuthUser
                }, "flex flex-col space-y-2"])
      }, [
        (__props.message.media && __props.message.media.length)
          ? (_openBlock(), _createBlock(_component_photo_provider, { key: 0 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.message.media, (image, imageKey) => {
                  return (_openBlock(), _createBlock(_component_photo_consumer, {
                    key: imageKey,
                    src: image.url
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("img", {
                          class: "flex w-full h-full rounded-xl object-cover pointer-events-none",
                          src: image.url
                        }, null, 8, _hoisted_3)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["src"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (__props.message.message)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: messageOptions
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", {
                  class: _normalizeClass([{
                        'bg-brand-dark-gray mr-auto' : !__props.isAuthUser,
                        'bg-brand-darkish-gray ml-auto' : __props.isAuthUser
                    }, "py-3 px-4 rounded-xl text-lg flex flex-col space-y-3"])
                }, [
                  _createVNode(UserListItem, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (viewProfile(__props.message.posted_by))),
                    user: __props.message.posted_by
                  }, null, 8, ["user"]),
                  _createElementVNode("div", {
                    class: "flex flex-col space-y-5",
                    innerHTML: sanitizeHtml(__props.message.message)
                  }, null, 8, _hoisted_5)
                ], 2)
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_6, _toDisplayString(messageTime.value), 1)
  ], 2))
}
}

})